import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import {
  CloseBoxIcon,
  WallateIcon,
  CaseIcon,
  SideMenuIcon,
} from "../../assets/svg/svg-icons";
import { useDispatch, useSelector } from "react-redux";
import "react-image-gallery/styles/css/image-gallery.css";
import "./account.css";
import Address from "../AdminPanel/common/Address/index";
import BasicInformation from "../AdminPanel/common/BasicInformation";
import { getApi } from "../../actions/structure.action";
import OrdersList from "./OrdersList";
import EnquiryList from "./EnquiryList";
import ReferralForm from "./ReferralForm";
import ReferralHistory from "./ReferralHistory";
import { useLocation } from "react-router-dom";
import { logoutUser } from "../../actions";
import { store } from "../../helpers";
import isEmpty from "../../utils/is-Empty";

const Account = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [showSideMenu, setShowSideMenu] = useState(false);

  const ref = useRef([]);

  const { auth, addresses } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const goto = params.get("goto");

    setTimeout(() => {
      if (goto === "orders") {
        handleScrollView(2);
      } else if (goto === "enquiries") {
        handleScrollView(3);
      } else if (goto === "address") {
        handleScrollView(1);
      } else if (goto === "referral") {
        handleScrollView(4);
      } else if (goto === "referral-history") {
        handleScrollView(6);
      }
    }, 500);
  }, [location]);

  useEffect(() => {
    console.log("IN ACCOUNT: addresses: ", addresses);

    if (!addresses?.loading && isEmpty(addresses?.data)) {
      handleScrollView(1);
    }
  }, [addresses]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    getApi("getBhreeAdminBasicTables", dispatch);
  }, []);

  const handleScrollView = (index) => {
    handleCloseSideMenu();

    setTimeout(() => {
      ref.current[index]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 500);
  };

  const handleCloseSideMenu = () => {
    setShowSideMenu(false);
  };

  const handleShowSideMenu = () => {
    setShowSideMenu(true);
  };

  const accountBanner = (
    <div className="account-banner-main-div text-uppercase">
      <p>{"HOME "}</p>
      <h2>{"My Account"}</h2>
    </div>
  );

  const accountSideMenu = (
    <>
      {/* =========================
          MOBILE SIDE MENU
      ========================== */}
      <div className="account-profile-side-menu-icon text-uppercase mobile">
        <Button onClick={handleShowSideMenu}>
          <SideMenuIcon />
        </Button>

        <Offcanvas
          show={showSideMenu}
          onHide={handleCloseSideMenu}
          placement="start"
        >
          <Offcanvas.Header closeButton></Offcanvas.Header>

          <Offcanvas.Body>
            <div className="account-side-menu-option">
              <div
                className="heading-menu active"
                style={{
                  borderRadius: "10px 10px 0px 0px",
                }}
              >
                <CloseBoxIcon />

                <h5 className="my-0 mx-2 text-uppercase">
                  {"my account"}
                </h5>
              </div>

              <div className="submenu">
                <p
                  className="mt-2 pointer text-uppercase"
                  onClick={() => handleScrollView(3)}
                >
                  {"My Enquiries"}
                </p>

                <p
                  className="mt-2 pointer text-uppercase"
                  onClick={() => handleScrollView(2)}
                >
                  {"My Orders"}
                </p>

                <p
                  className="mt-2 pointer text-uppercase"
                  onClick={() => handleScrollView(0)}
                >
                  {"Business Information"}
                </p>

                <p
                  className="mt-2 pointer text-uppercase"
                  onClick={() => handleScrollView(1)}
                >
                  {"Address"}
                </p>

                <p
                  className="mt-2 pointer text-uppercase"
                  onClick={() => handleScrollView(5)}
                >
                  {"my coupons"}
                </p>

                {/* Referral */}
                <p
                  className="mt-2 pointer text-uppercase"
                  onClick={() => handleScrollView(4)}
                >
                  {"Referral"}
                </p>

                {/* Referral History */}
                <p
                  className="mt-2 pointer text-uppercase"
                  onClick={() => handleScrollView(6)}
                >
                  {"Referral History"}
                </p>
              </div>
            </div>

            {/* =========================
                PAYMENT MENU
            ========================== */}

            {/* 
            <div className="account-side-menu-option">
              <div className="heading-menu">
                <WallateIcon />
                <h5 className="my-0 mx-2">
                  {"payment"}
                </h5>
              </div>

              <div className="submenu">
                <p
                  className="mt-2 pointer"
                  onClick={() => handleScrollView(3)}
                >
                  {"saved upi"}
                </p>

                <p
                  className="mt-2 pointer"
                  onClick={() => handleScrollView(4)}
                >
                  {"saves cards"}
                </p>
              </div>
            </div>
            */}

            {/* =========================
                MY STUFFS
            ========================== */}

            <div
              className="account-side-menu-option"
              style={{ display: "none" }}
            >
              <div className="heading-menu">
                <CaseIcon />

                <h5 className="my-0 mx-2 text-uppercase">
                  {"my stuffs"}
                </h5>
              </div>

              <div className="submenu">
                <p
                  className="mt-2 pointer text-uppercase"
                  onClick={() => handleScrollView(5)}
                >
                  {"my coupons"}
                </p>

                <p
                  className="mt-2 pointer text-uppercase"
                  onClick={() => handleScrollView(6)}
                >
                  {"my reviews & Ratings"}
                </p>

                <p
                  className="mt-2 pointer text-uppercase"
                  onClick={() => handleScrollView(7)}
                >
                  {"all notification"}
                </p>
              </div>
            </div>

            {/* =========================
                LOGOUT
            ========================== */}

            <div className="account-side-menu-option text-uppercase">
              <Button
                onClick={() => {
                  store.dispatch(logoutUser());

                  window.location.href = "/";
                }}
              >
                {"Log Out"}
              </Button>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>

      {/* =========================
          DESKTOP SIDE MENU
      ========================== */}

      <div
        className="account-side-menu text-uppercase desktop"
        style={{
          position: "fixed",
          top: "85px",
          width: "290px",
        }}
      >
        <div className="account-side-menu-option">
          <div
            className="heading-menu active"
            style={{
              borderRadius: "10px 10px 0px 0px",
            }}
          >
            <CloseBoxIcon />

            <h5 className="my-0 mx-2">
              {"my account"}
            </h5>
          </div>

          <div className="submenu">
            <p
              className="mt-2 pointer"
              onClick={() => handleScrollView(3)}
            >
              {"My Enquiries"}
            </p>

            <p
              className="mt-2 pointer"
              onClick={() => handleScrollView(2)}
            >
              {"My Orders"}
            </p>

            <p
              className="mt-2 pointer"
              onClick={() => handleScrollView(0)}
            >
              {"Business Information"}
            </p>

            <p
              className="mt-2 pointer"
              onClick={() => handleScrollView(1)}
            >
              {"Address"}
            </p>

            <p
              className="mt-2 pointer"
              onClick={() => handleScrollView(5)}
            >
              {"my coupons"}
            </p>

            {/* Referral */}
            <p
              className="mt-2 pointer"
              onClick={() => handleScrollView(4)}
            >
              {"Referral"}
            </p>

            {/* Referral History */}
            <p
              className="mt-2 pointer"
              onClick={() => handleScrollView(6)}
            >
              {"Referral History"}
            </p>
          </div>
        </div>

        {/* =========================
            PAYMENT
        ========================== */}

        {/*
        <div className="account-side-menu-option">
          <div className="heading-menu">
            <WallateIcon />

            <h5 className="my-0 mx-2">
              {"payment"}
            </h5>
          </div>

          <div className="submenu">
            <p
              className="mt-2 pointer"
              onClick={() => handleScrollView(3)}
            >
              {"saved upi"}
            </p>

            <p
              className="mt-2 pointer"
              onClick={() => handleScrollView(4)}
            >
              {"saves cards"}
            </p>
          </div>
        </div>
        */}

        {/* =========================
            MY STUFFS
        ========================== */}

        <div
          className="account-side-menu-option"
          style={{ display: "none" }}
        >
          <div className="heading-menu">
            <CaseIcon />

            <h5 className="my-0 mx-2">
              {"my stuffs"}
            </h5>
          </div>

          <div
            className="submenu"
            style={{
              borderRadius: "0px 0px 10px 10px",
            }}
          >
            <p
              className="mt-2 pointer"
              onClick={() => handleScrollView(5)}
            >
              {"my coupons"}
            </p>

            <p
              className="mt-2 pointer"
              onClick={() => handleScrollView(6)}
            >
              {"my reviews & Ratings"}
            </p>

            <p
              className="mt-2 pointer"
              onClick={() => handleScrollView(7)}
            >
              {"all notification"}
            </p>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <section className="account-main-section">
      <div className="container-fluid pt-1 pb-5">
        <Row className="m-0">

          {/* =========================
              LEFT SIDE MENU
          ========================== */}

          <Col
            xs={12}
            sm={12}
            md={3}
            className="py-2"
          >
            {accountSideMenu}
          </Col>

          {/* =========================
              MAIN CONTENT
          ========================== */}

          <Col
            xs={12}
            sm={12}
            md={9}
            className="py-2"
          >

            {/* My Enquiries */}
            <div
              ref={(el) => (ref.current[3] = el)}
            >
              <EnquiryList />
            </div>

            {/* My Orders */}
            <div
              className="mt-4"
              ref={(el) => (ref.current[2] = el)}
            >
              <OrdersList />
            </div>

            {/* Business Information */}
            <div
              className="mt-4"
              ref={(el) => (ref.current[0] = el)}
            >
              <BasicInformation
                title="Business information"
              />
            </div>

            {/* Address */}
            <div
              className="mt-4"
              ref={(el) => (ref.current[1] = el)}
            >
              <Address />
            </div>

            {/* Referral Form */}
            <div
              className="mt-4"
              ref={(el) => (ref.current[4] = el)}
            >
              <ReferralForm />
            </div>

            {/* My Coupons */}
            <div
              className="mt-4"
              ref={(el) => (ref.current[5] = el)}
            >
              {/* Existing coupons section can come here */}
            </div>

            {/* Referral History */}
            <div
              className="mt-4"
              ref={(el) => (ref.current[6] = el)}
            >
              <ReferralHistory />
            </div>

          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Account;